import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";

export default function AdminQuestions() {
  const [qs, setQs] = useState([]);
  const [text, setText] = useState("");

  const load = async () => { try { const r = await api.get("/questions"); setQs(r.data.filter(q=>q.scope==="global")); } catch {} };
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    try { await api.post("/questions", { text, scope: "global" }); toast.success("Added"); setText(""); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };
  const del = async (id) => { try { await api.delete(`/questions/${id}`); load(); } catch { toast.error("Failed"); } };

  return (
    <div className="p-8 max-w-3xl">
      <h1 className="heading-mono text-4xl amber amber-glow uppercase">// XP Questionnaire</h1>
      <div className="mono text-xs text-[#A0A0A0] mt-1 tracking-widest uppercase mb-8">Global questions used by all campaigns</div>
      <form onSubmit={add} className="flex gap-2 mb-6" data-testid="admin-q-form">
        <input className="input-term flex-1" placeholder="e.g. Did you face off against a xenomorph?" value={text} onChange={e=>setText(e.target.value)} required data-testid="admin-q-input" />
        <button className="btn-amber flex items-center gap-1" data-testid="admin-q-submit"><Plus size={14}/> Add</button>
      </form>
      <div className="panel">
        {qs.map(q => (
          <div key={q.id} data-testid={`admin-q-${q.id}`} className="flex items-center justify-between p-3 border-b border-[#222]">
            <span>{q.text}</span>
            <button className="text-[#FF2A2A]" onClick={()=>del(q.id)}><Trash2 size={14}/></button>
          </div>
        ))}
        {qs.length === 0 && <div className="p-6 text-center mono text-[#A0A0A0]">// no global questions</div>}
      </div>
    </div>
  );
}
